require("./galhad_galhadLtr_site_searchComponenta.less")
require("./galhad_galhadLtr_site_searchComponenta_redesigned.less")
import * as classNames from "classnames"
import * as axios from "axios"
import { addAxiosDateTransformerSettings } from "../../../../../utils/network/axiosDateTransformer"
import { HyperLink, HyperLinkBuilder, SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink"
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces"



interface GalhedArticle {
    id: string;
    title: string;
    roof: string;
    dateUpdatedOnSite: string;
    promotionImageUrl: string;
    details: string;
    fallenDate: string;
    fallenDetails: string;
    publishedLink?: string;
}

interface GalhedSearchState {
    searchQuery: string;
    isOpen: boolean;
    data: GalhedArticle[];
    filteredData: GalhedArticle[];
    isLoading: boolean;
    selectedIndex: number;
}

interface GalhedSearchProps {
    isLTR: boolean;
    mainTitle: string;
    instructionText: string;
    searchPlaceholder: string;
    bottomLinkUrl: string
    textLink: string
    shouldDisplayBottomLink: boolean
    bottomlinkTarget: LinkTargetProperties
    newDesign?: boolean
}

export class GalhedSearchComponenta extends React.Component<GalhedSearchProps, GalhedSearchState> {
    public static siteScriptName = "GalhedSearchComponenta"
    private searchWrapperRef: HTMLDivElement | null = null

    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
            isOpen: false,
            data: [],
            filteredData: [],
            isLoading: true,
            selectedIndex: -1
        };
    }

    componentDidMount() {
        this.fetchData();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    private handleClickOutside = (event: MouseEvent) => {
        if (this.searchWrapperRef && !this.searchWrapperRef.contains(event.target as Node)) {
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false,
                    searchQuery: '',
                    filteredData: [],
                    selectedIndex: -1
                });
            }
        }
    }

    private fetchData = () => {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        axiosInstance.get(`/iphone/json/api/article/gal_hed/get_all/`)
            .then((res: any) => {
                const articles = res.data.articles || [];
                this.setState({
                    data: articles,
                    filteredData: articles,
                    isLoading: false
                });
            })
            .catch(err => {
                console.error("Error fetching gal_hed data:", err);
                this.setState({ isLoading: false });
            });
    }

    handleSearchClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    handleSearchChange = (e: any) => {
        const query = e.target.value;
        const { data } = this.state;

        // Only filter if query has 3 or more characters
        const filtered = query.length >= 3
            ? data.filter((item: GalhedArticle) => {
                // Search only in title field
                return item.title && item.title.toLowerCase().includes(query.toLowerCase());
            }).slice(0, 10) // Limit to 10 results
            : [];

        this.setState({
            searchQuery: query,
            filteredData: filtered,
            selectedIndex: -1
        });
    }

    handleKeyDown = (e: React.KeyboardEvent) => {
        const { filteredData, selectedIndex } = this.state;

        if (filteredData.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex < filteredData.length - 1 ? selectedIndex + 1 : 0
                });
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : filteredData.length - 1
                });
                break;
            case 'Enter':
                e.preventDefault();
                if (selectedIndex >= 0 && selectedIndex < filteredData.length) {
                    const article = filteredData[selectedIndex];
                    if (article.publishedLink) {
                        window.location.href = article.publishedLink;
                    }
                }
                break;
            case 'Escape':
                this.setState({
                    isOpen: false,
                    searchQuery: '',
                    filteredData: [],
                    selectedIndex: -1
                });
                break;
        }
    }



    handleSearchSubmit = (e: any) => {
        e.preventDefault();
        // Implement search logic here
        console.log('Searching for:', this.state.searchQuery);
    }

    public render() {

        const { searchQuery, isOpen, filteredData, isLoading, selectedIndex } = this.state;
        const { mainTitle, instructionText, searchPlaceholder, shouldDisplayBottomLink, isLTR, bottomLinkUrl, textLink, bottomlinkTarget, newDesign } = this.props;

        return (
            <div className={classNames({ "GalhedSearchContainer": !newDesign, "GalhedSearchContainer_redesign": newDesign, "ltrSite": this.props.isLTR })}>
                <div className="searchHeader">
                    <div className="searchHeaderContent">
                        <div className="searchTitle">
                            <p className="mainTitle">{mainTitle}</p>
                            <div className="titleUnderline">
                                <div className="whiteBar" />
                                <div className="redBar" />
                            </div>
                        </div>
                        <form onSubmit={this.handleSearchSubmit} className="searchbarWrapper">
                            {isOpen ? (
                                <div className="searchInputWrapper" ref={(ref) => this.searchWrapperRef = ref}>
                                    <input
                                        type="text"
                                        className="searchInput"
                                        value={searchQuery}
                                        onChange={this.handleSearchChange}
                                        onKeyDown={this.handleKeyDown}
                                        placeholder={searchPlaceholder}
                                        spellcheck="false"
                                        id="soldierSearchInput"
                                        autoFocus
                                    />
                                    {searchQuery.length >= 3 && filteredData.length > 0 && (
                                        <div className="searchDropdown">
                                            {filteredData.map((article: GalhedArticle, index: number) => (
                                                <SimpleLinkRenderer
                                                    key={article.id}
                                                    className={classNames("dropdownItem", { "selected": index === selectedIndex })}
                                                    href={article.publishedLink}       
                                                >
                                                    <div className="itemTitle">{article.title}</div>
                                                </SimpleLinkRenderer>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <button type="button" className="searchbar" onClick={this.handleSearchClick}>
                                    <div className="searchIconWrapper">
                                       <svg preserveAspectRatio="none" className="searchIcon"  width="22" height="22" overflow="visible" style={{display: "block"}} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path id="icon" fillRule="evenodd" clipRule="evenodd" d="M17.6771 16.4084C19.1272 14.673 20 12.4384 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C12.5026 20 14.7906 19.0807 16.5445 17.5613L20.6208 21.7633C20.9363 22.0789 21.4478 22.0789 21.7633 21.7633C22.0789 21.4478 22.0789 20.9363 21.7633 20.6208L17.6771 16.4084ZM18.4 10C18.4 14.6392 14.6392 18.4 10 18.4C5.36081 18.4 1.6 14.6392 1.6 10C1.6 5.36081 5.36081 1.6 10 1.6C14.6392 1.6 18.4 5.36081 18.4 10Z" fill="#2B3D59" />
                                        </svg>
                                    </div>
                                    <p className="searchPlaceholder">{searchPlaceholder}</p>
                                </button>
                            )}
                        </form>
                    </div>
                    <p className="instructionText">{instructionText}</p>
                </div>

            {shouldDisplayBottomLink && 
                (newDesign ?
                <div className="linkWrapper">
                    <div className="Line" />
                    <SimpleLinkRenderer className={`linkToList ${isLTR ? "ltr" : "rtl"}`} href={bottomLinkUrl}>
                          <span dangerouslySetInnerHTML={{ __html: textLink}} />
                          <span className="arrow" />
                    </SimpleLinkRenderer>
                    <div className="Line" />
                </div>
                : 
                <div className="linkToList"><SimpleLinkRenderer href={bottomLinkUrl}><span dangerouslySetInnerHTML={{ __html: textLink }}></span><span className="arrow" /></SimpleLinkRenderer></div>
                )
            }
            </div>
        )
    }
}
